export const MY_NOMINEE_STORE_NAME = 'my-nominee';



// WEBPACK FOOTER //
// ./src/constants/store.js